<template>

  <modalo
    :title="scoreform.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => scoreform">

    <form
      id="scoreform-form"
      v-on:submit.prevent="saveScoreform(scoreform)">
      <ScoreformForm
        :initScoreform="scoreform"
        :validateErrors="validateErrors"
        @update="scoreform=$event" />
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="scoreform-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="scoreform._id"
          type="button"
          class="btn btn-danger"
          @click="deleteScoreform(scoreform._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import ScoreformForm from './ScoreformForm.vue'
export default {
  name: 'ScoreformModalForm',
  components: {
    ScoreformForm
  },
  props: {
    initScoreform: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      scoreform: this.defaultValues(this.initScoreform),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'groups': []
      }, values)
    },
    addGroup () {
      this.scoreform.groups.push({
        'name': '',
        'questions': ['']
      })
    },
    removeGroup (index) {
      this.scoreform.groups.splice(index, 1)
    },
    addQuestion (items) {
      items.push('')
    },
    removeQuestion (items, index) {
      items.splice(index, 1)
    },
    /* hideModal  */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveScoreform
    */
    saveScoreform (data) {
      if (data._id) this.updateScoreform(data)
      else this.createScoreform(data)
    },
    /*
    createScoreform
    */
    createScoreform (data) {
      this.loading = true

      this.$store
      .dispatch('createScoreform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateScoreform
    */
    updateScoreform (data) {
      console.log(data)
      this.loading = true

      this.$store
      .dispatch('updateScoreform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteScoreform (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteScoreform', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Scoreform/ScoreformModalForm.vue